import { createContext } from "react";

const DashboardContext = createContext({

    isLoading: false,
    usersCount: 0,
    setUsersCount: () => {},
    areaCount: 0,
    setAreaCount: () => {},
    personsCount: 0,
    setPersonsCount: () => {},
    placeCount: 0,
    setPlaceCount: () => {},
    productCount: 0,
    setProductCount: () => {},
    ordersCount: 0,
    setOrdersCount: () => {},
    orders2Count: 0,
    setOrders2Count: () => {},
    jobCategoryCount: 0,
    setJobCategoryCount: () => {},
    productCategoryCount: 0,
    setProductCategoryCount: () => {},
    placeCategoryCount: 0,
    setPlaceCategoryCount: () => {},
    commentsCount: 0,
    setCommentsCount: () => {},
    viewersCount: 0,
    setViewersCount: () => {},

});

export default DashboardContext;
